<template>
<v-main v-scroll="onScroll">
  <header-common :logo_background="backgroundUrl" :page_title="page_title" :onTop="onTop" v-on:editContent="editContent"></header-common>
  <v-container class="mb-5" style="margin-top:75px;">
    <v-row>
      <v-col cols="12" md="5">
        <img @click="editImage('page.about.image1')" :src="$baseURL + 'uploads/'+dv(assets, 'page.about.image1')" width="100%" />
        <div class="image-badge text-h5 text-md-h-4">
          <div @click="editContent('page.about.slogan')">{{ $vuetify.lang.t('$vuetify.page.about.slogan') }} </div>
        </div>
      </v-col>
      <v-col cols="12" offset-md="1" md="6" class="text-left">
        <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray; opacity:.4;" @click="editContent('page.about.achievement')">{{ $vuetify.lang.t('$vuetify.page.about.achievement') }}</span><br/>
        <span style="color:#414a52; font-weight:700; font-size:38px; line-height:75px;" @click="editContent('page.about.achievement_title')">{{ $vuetify.lang.t('$vuetify.page.about.achievement_title') }}</span>
        <p style="line-height:25px;" @click="editContent('page.about.achievement_p1')">{{ $vuetify.lang.t('$vuetify.page.about.achievement_p1') }} </p>
        <p style="line-height:25px;"  @click="editContent('page.about.achievement_p2')">{{ $vuetify.lang.t('$vuetify.page.about.achievement_p2') }}</p>
        <v-list class="list-about">
          <v-list-item><v-icon>mdi-bullseye</v-icon>  <span @click="editContent('page.about.achievement_list_1')">{{ $vuetify.lang.t('$vuetify.page.about.achievement_list_1') }}</span></v-list-item>
          <v-list-item><v-icon>mdi-bullseye</v-icon>  <span @click="editContent('page.about.achievement_list_2')">{{ $vuetify.lang.t('$vuetify.page.about.achievement_list_2') }}</span></v-list-item>
          <v-list-item><v-icon>mdi-bullseye</v-icon>  <span @click="editContent('page.about.achievement_list_3')">{{ $vuetify.lang.t('$vuetify.page.about.achievement_list_3') }}</span></v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
  <v-container>
    <v-row class="mt-5 mb-5">
      <v-col cols="12" md="7" class="text-left mt-2" style="line-height:30px;">
        <p class="text-h3" style="width:75%; font-weight:700;"  @click="editContent('page.about.mission_title')" >{{ $vuetify.lang.t('$vuetify.page.about.mission_title') }}</p>
        <p style="font-weight:700;" @click="editContent('page.about.mission_subtitle')" >{{ $vuetify.lang.t('$vuetify.page.about.mission_subtitle') }}</p>
        <p @click="editContent('page.about.mission_paragraph')">{{ $vuetify.lang.t('$vuetify.page.about.mission_paragraph') }}</p>
      </v-col>
      <v-col cols="12" md="5">
        <div @click="editImage('page.about.image2')">
          <img class="about-image" :src="$baseURL + 'uploads/'+dv(assets, 'page.about.image2')" v-if="String(dv(assets, 'page.about.image2')).length > 0" />
          <div v-else style="width: 100%; height: 100%; background: #ececec;">
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
  
  <v-container style="padding: 0px;" id="certification" fluid>
    <v-container style="margin: 0 auto;">
      <v-row align="center" style="margin: 48px 0px;">
        <v-col cols="12" md="6">
          <img :src="isoImage" style="width: 85%; height: 85%;" />
        </v-col>
        <v-col cols="12" md="6">
          <div style="width:75%;">
            <div class="font-back-content" style="left:unset; right:unset; font-size:84px;">Certifié</div>
            <p class="text-h3" style="font-weight:700; text-align: left; font-size: 22px; text-transform: uppercase;"  @click="editContent('page.about.certification_title')" >{{ $vuetify.lang.t('$vuetify.page.about.certification_title') }}</p>
            <p style="font-weight:700;  text-align: left; font-size: 18px;" @click="editContent('page.about.certification_subtitle')" >{{ $vuetify.lang.t('$vuetify.page.about.certification_subtitle') }}</p>
            <p @click="editContent('page.about.certification_paragraph')" style=" text-align: left; font-size: 18px;">{{ $vuetify.lang.t('$vuetify.page.about.certification_paragraph') }}</p>
            <img :src="certif" width="240" style="margin: 20px 0px;" />

            <div>
              <v-btn text link href="https://www.certipedia.com/quality_marks/9000022841" target="_blank" @click="editContent('page.about.certification_link')">{{ $vuetify.lang.t('$vuetify.page.about.certification_link') }}</v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
  <v-container style="background: #fff; text-align:center; width:75%; margin: 0 auto;" fluid>
    <v-container>
      <div class="about-cart" style="min-height:550px; padding-top:200px;" :style="{ backgroundImage: `url(${aboutCart})` }">
        <v-row>
          <v-col cols="12" md="12">
            <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;"  @click="editContent('pages.about.stats_title')">{{ $vuetify.lang.t('$vuetify.pages.about.stats_title') }}</span><br/>
            <span style="color:#414a52; font-weight:700; font-size:38px;"  @click="editContent('pages.about.stats_subtitle')">{{ $vuetify.lang.t('$vuetify.pages.about.stats_subtitle') }}</span>
          </v-col>
          <v-row style="padding-bottom:175px; padding-top:55px;">
            <v-col cols="12" md="4" style="vertical-align: bottom; text-align:center;">
              <span style="font-size:72px; font-weight:700;" @click="editContent('pages.home.widget_1_number')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_1_number') }}</span>
              <span style="font-size:48px; font-weight:700;" @click="editContent('pages.home.widget_1_unit')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_1_unit') }}</span> 
              <br/>
              <span style="font-size:18px; font-weight:700;" @click="editContent('pages.home.widget_1_label')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_1_label') }}</span>
            </v-col>
            <v-col cols="12" md="4" style="vertical-align: bottom; text-align:center;">
              <span style="font-size:72px; font-weight:700;" @click="editContent('pages.home.widget_2_number')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_2_number') }}</span>
              <span style="font-size:48px; font-weight:700;" @click="editContent('pages.home.widget_2_unit')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_2_unit') }}</span> 
              <br/>
              <span style="font-size:18px; font-weight:700;" @click="editContent('pages.home.widget_2_label')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_2_label') }}</span>

            </v-col>
            <v-col cols="12" md="4" style="vertical-align: bottom; text-align:center;">
              <span style="font-size:72px; font-weight:700;" @click="editContent('pages.home.widget_3_number')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_3_number') }}</span>
              <span style="font-size:48px; font-weight:700;" @click="editContent('pages.home.widget_3_unit')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_3_unit') }}</span>
              <br/>
              <span style="font-size:18px; font-weight:700;" @click="editContent('pages.home.widget_3_label')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_3_label') }}</span> 
              
            </v-col>
          </v-row>
        </v-row>
      </div>
    </v-container>
  </v-container>
  <v-container style="background:#30373f url('https://demo.artureanec.com/html/transx/img/footer-bg.png') no-repeat right bottom;" fluid>
    <v-container>
      <v-row>
        <v-col md="6" style="text-align:left; margin-top:20px;">
          <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;" @click="editContent('pages.about.team_title')">{{ $vuetify.lang.t('$vuetify.pages.about.team_title') }}</span><br/>
          <span style="color:white; font-weight:700; font-size:38px;"  @click="editContent('pages.about.team_subtitle')">{{ $vuetify.lang.t('$vuetify.pages.about.team_subtitle') }}</span>
          <p style="color:white; line-height:30px; margin-top:5px;"  @click="editContent('pages.about.team_description')">{{ $vuetify.lang.t('$vuetify.pages.about.team_description') }}</p>
        </v-col>
        <v-col md="3" v-for="(item, index) in team" :key="`team-${index}`">
          <div class="team-member" style="position: relative;">
            <img :src="item.profile_picture" />
            <div class="team-description">
              <p class="member-name">Lorem ipsum</p>
              <p class="member-position">Company CEO</p>
              <div>
                <v-btn dark icon><v-icon>mdi-facebook</v-icon></v-btn>
                <v-btn dark icon><v-icon>mdi-google-plus</v-icon></v-btn>
                <v-btn dark icon><v-icon>mdi-linkedin</v-icon></v-btn>
              </div>
            </div>
          </div>
        </v-col>
      </v-row> 
    </v-container>
  </v-container>
  <v-container style=" height:auto">
    <v-row>
      <v-col md="12" style="text-align:center; margin: 0 auto; margin-top:100px;">
        <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;" @click="editContent('pages.about.services_title')">{{ $vuetify.lang.t('$vuetify.pages.about.services_title') }}</span><br/>
        <span style="color:#414a52; font-weight:700; font-size:38px;" @click="editContent('pages.about.services_subtitle')">{{ $vuetify.lang.t('$vuetify.pages.about.services_subtitle') }}</span>
      </v-col>
    </v-row> 
    <v-container>
      <v-row>
      <v-col cols="12" md="3" style="text-align:center; margin-top:10px;">
        <img src="https://i.imgur.com/oXPlqGU.png" width="64px" /><br/>
        <div class="feature-title" @click="editContent('pages.about.services_1')">{{ $vuetify.lang.t('$vuetify.pages.about.services_1') }}</div>
      </v-col>
      <v-col cols="12" md="3" style="text-align:center; margin-top:10px;">
        <img src="https://i.imgur.com/QzgQPw3.png" width="64px" /><br/>
        <div class="feature-title" @click="editContent('pages.about.services_2')">{{ $vuetify.lang.t('$vuetify.pages.about.services_2') }}</div>
      </v-col>
      <v-col cols="12" md="3" style="text-align:center; margin-top:10px;">
        <img src="https://i.imgur.com/KfM5YQa.png" width="64px" /><br/>
        <div class="feature-title" @click="editContent('pages.about.services_3')">{{ $vuetify.lang.t('$vuetify.pages.about.services_3') }}</div>
      </v-col>
      <v-col cols="12" md="3" style="text-align:center; margin-top:10px;">
        <img src="https://i.imgur.com/6TJd9ie.png" width="64px" /><br/>
        <div class="feature-title" @click="editContent('pages.about.services_4')">{{ $vuetify.lang.t('$vuetify.pages.about.services_4') }}</div>
      </v-col>
      <v-col cols="12" md="3" style="text-align:center; margin-top:10px;">
        <img src="https://i.imgur.com/2jrmPc3.png" width="64px" /><br/>
        <div class="feature-title" @click="editContent('pages.about.services_5')">{{ $vuetify.lang.t('$vuetify.pages.about.services_5') }}</div>
      </v-col>
      <v-col cols="12" md="3" style="text-align:center; margin-top:10px;">
        <img src="https://i.imgur.com/ru5fHaS.png" width="64px" /><br/>
        <div class="feature-title" @click="editContent('pages.about.services_6')">{{ $vuetify.lang.t('$vuetify.pages.about.services_6') }}</div>
      </v-col>
      <v-col cols="12" md="3" style="text-align:center; margin-top:10px;">
        <img src="https://i.imgur.com/X8En7Xk.png" width="64px" /><br/>
        <div class="feature-title" @click="editContent('pages.about.services_7')">{{ $vuetify.lang.t('$vuetify.pages.about.services_7') }}</div>
      </v-col>
      <v-col cols="12" md="3" style="text-align:center; margin-top:10px;">
        <img src="https://i.imgur.com/9cN2p4Q.png" width="64px" /><br/>
        <div class="feature-title" @click="editContent('pages.about.services_8')">{{ $vuetify.lang.t('$vuetify.pages.about.services_8') }}</div>
      </v-col>
    </v-row>
    </v-container>
  </v-container>
  <v-container style="padding:0px; background:#f4f6f5;" v-if="false" fluid>
    <v-col md="10" style="text-align:center; margin: 0 auto; margin-top:100px;">
        <div class="font-back-content" style="left:87px; font-size:84px;">{{ $vuetify.lang.t('$vuetify.pages.about.partners_title') }}</div>
        <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;" @click="editContent('pages.about.partners_subtitle')">{{ $vuetify.lang.t('$vuetify.pages.about.partners_subtitle') }}</span><br/>
        <span style="color:#414a52; font-weight:700; font-size:38px;" @click="editContent('pages.about.partners_subtitle_2')">{{ $vuetify.lang.t('$vuetify.pages.about.partners_subtitle_2') }}</span>
      </v-col>
      <v-container>
        <v-row>
          <v-col cols="12" md="3">
            <div style="margin:10px; background: white; height:200px; line-height:200px;"><img style="vertical-align:middle;" src="https://demo.artureanec.com/html/transx/img/logo_1.png" /></div>
          </v-col>
          <v-col cols="12" md="3"><div style="margin:10px; background: white; height:200px; line-height:200px;"><img style="vertical-align:middle;" src="https://demo.artureanec.com/html/transx/img/logo_2.png" /></div></v-col>
          <v-col cols="12" md="3"><div style="margin:10px; background: white; height:200px; line-height:200px;"><img style="vertical-align:middle;" src="https://demo.artureanec.com/html/transx/img/logo_3.png" /></div></v-col>
          <v-col cols="12" md="3"><div style="margin:10px; background: white; height:200px; line-height:200px;"><img style="vertical-align:middle;" src="https://demo.artureanec.com/html/transx/img/logo_4.png" /></div></v-col>
        </v-row>
      </v-container>
  </v-container>
  <footer-prime v-on:editContent="editContent"></footer-prime>
</v-main>
</template>

<script>
import headerCommon from "./commons/header"
import footerPrime from "./commons/footer"
import logo_light from "../../assets/logo_light.png"
import logo_dark from "../../assets/logo_dark.png"
import aboutImg from "../../assets/section_1.jpg"
import aboutCart from "../../assets/about_cart.png"
import isoImage from "../../assets/prime.png"
import certif from '../../assets/TR-Testmark_9000022841_EN_CMYK_with-QR-Code.png'
export default {
  name: 'homepage',
  data: () => ({
      type: ['20" ', '40" '],
      inflammable: false,
      gerbable: false,
      page_title: 'about',
      backgroundUrl: logo_light,
      aboutImage: aboutImg,
      aboutCart: aboutCart,
      isoImage: isoImage,
      certif: certif,
      assets: null,
      onTop: true,
      team: [
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_1.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_2.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_3.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_4.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_5.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_6.jpg'}
      ]
    }),
    async mounted() {
      await this.axios
      .get("../website/get/assets")
      .then(res => this.assets = res.data)
    },
    methods: {
      dv (obj, path) {
        return path
          .replace(/\[|\]\.?/g, '.')
          .split('.')
          .filter(s => s)
          .reduce((acc, val) => acc && acc[val], obj);
      },
      onScroll() {
        if(document.documentElement.scrollTop === 0 ){
          this.backgroundUrl = logo_light
          this.onTop = true
        }else{
          this.backgroundUrl = logo_dark
          this.onTop = false
        }
      },
      editContent(name){
        //console.log(name+' - index')
        this.$emit("edit", {name: name, page: 'A propos'})
      },
      editImage(name){
        //console.log(name+' - index')
        this.$emit("editImage", {name: name, page: 'A propos'})
      }
    },
    components: {
      headerCommon, footerPrime
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');
.list-about .v-icon {
  padding-right:20px;
  color:#1976d2;
}
*{
  transition: all .3s ease-in;

}
.team-description {
    position: absolute;
    background: #003d90;
    bottom: 5px;
    padding:15px;
    left:1px;
    color: white;
    overflow: hidden;
    width:85%;
    height:75px;
    clip-path: polygon(90% 0,100% 15%,100% 100%,0 100%,0 0);
    text-align:left;
}
.team-member .member-name {
  font-weight:700;
  margin-bottom: 0px;
  letter-spacing:1.2px;
}
.team-member {
  bottom:0px;
}
.team-member:hover {
  bottom:5px;
}
.team-member .member-position, .team-member .v-btn {
    color: #427ccb;
    font-size: 14px;
    font-weight: 700;
}
.team-member:hover .team-description{
  height:120px;
}
.list-about .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){
  color: rgb(65, 74, 82) !important;
  line-height:25px;
  padding-bottom: 15px;
}
.image-badge{
  width:340px;
  min-height: 100px;
  position: relative;
  background: #003d90 url('https://demo.artureanec.com/html/transx/img/badge-img.png') no-repeat bottom right;
  background-size:contain;
  color: white;
  padding:15px 10px;
  bottom: 65px;
  left: 0;
  font-weight:700;
  clip-path: polygon(90% 0,100% 16%,100% 100%,0 100%,0 0);
  text-align: left;
  text-transform: capitalize;
}
.about-cart{
  width:100%;
  height:fit-content;
  background-size:cover;
}
.about-image{
  width:100%;
  min-height:400px;
}
* {
  font-family: 'Inter', sans-serif;
}
.footer-link:before{
  opacity: 0 !important;
}
.footer-link:hover {
  background: transparent;
  
}
.footer-link {
  color: white !important;
}
.footer-link:after {
  position: absolute;
  min-height:0px;
  height: 2px;
  left: 15px;
  right: 0;
  bottom: 0px;
  content: "";
  background: #2196f3;
  opacity:0;
  transition: all .2s ease-in-out;
  width:0;
}
.footer-link:hover:after{
  opacity: 1;
  width:35px;
  
}
.on-hover {
  background: #1976d2;
  color: white!important;
}
.on-hover-about {
  background: white;
  color: #515151!important;
}
.footer-list p {
  margin-bottom: 10px;
  color: #e8edf4;
  font-size: 14px;
  letter-spacing: 0px;
}
.footer-list p b{
  color: white;
}
.feature-content{
  font-size: 14px;
  letter-spacing: 1px;
  padding-top: 10px;
  line-height: 26px;
}

.feature-title{
  padding-top: 20px;
  font-size: 18px;
  font-weight: 700;
}
.back-head{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255,255,255,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
.font-back-content{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(0,0,0,0.2);
  position: absolute;
  pointer-events: none;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
#header-website .v-btn{
  border-radius: 20px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.headline {
  font-size: 64px;
  text-shadow: 0 0 20px rgba(0,0,0,0.6);
  font-weight: 700;
}
.text-caption{
  width:50%;
  text-align: center;
  margin: 0 auto;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/website/about.vue